export default {
  nav: {
    brand: "USFans Link",
    home: "Strona główna",
    categories: "Kategorie",
    guides: "Poradniki",
    faq: "FAQ",
    explore: "Przeglądaj arkusz",
    shoppingGuide: "Przewodnik zakupowy",
  },
  hero: {
    eyebrow: "Centrum zasobów USFans Spreadsheet",
    title: "Poznaj USFans Spreadsheet: kategorie, poradniki i zasoby",
    description:
      "Odkryj uporządkowane centrum informacji o USFans Spreadsheet — przeglądaj kategorie modowe, czytaj praktyczne poradniki, porównuj zasoby i znajdź wszystko, czego potrzebujesz, w jednym spokojnym i łatwym miejscu.",
    trust: "Niezależne źródło • Regularnie aktualizowane • Łatwa nawigacja • Bezpieczeństwo na pierwszym miejscu",
    searchPlaceholder: "Szukaj twórców, kategorii, poradników lub tematów...",
  },
  main: {
    usfansSpreadsheet: "USFans Spreadsheet",
    buyNow: "Kup teraz",
  },
  dropdown: {
    label: "Przejdź do kategorii",
    placeholder: "Wybierz kategorię...",
  },
  categoriesSection: {
    title: "Przeglądaj kategorie",
    subtitle:
      "Poznaj pełną gamę kategorii modowych i lifestyle'owych — każda prowadzi do odpowiadającej sekcji na głównej stronie.",
    browseAll: "Przeglądaj wszystkie kategorie",
  },
  categories: {
    shoes: "Buty",
    hoodies: "Bluzy/Swetry",
    tshirts: "Koszulki",
    jackets: "Kurtki",
    pants: "Spodnie/Szorty",
    headwear: "Nakrycia głowy",
    sets: "Zestawy",
    underwear: "Bielizna",
    jersey: "Koszulki sportowe",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    other: "Inne",
  },
  what: {
    title: "Czym jest USFans Spreadsheet?",
    p1: "USFans Spreadsheet to uporządkowane źródło, które ułatwia odkrywanie, porównywanie i zrozumienie informacji związanych z USFans. Zamiast szukać po rozproszonych stronach, możesz przeglądać uporządkowane kategorie obejmujące buty, bluzy, kurtki, akcesoria i wiele więcej.",
    p2: "To przyjazny punkt wyjścia: przejrzyj listę kategorii, wybierz to, co Cię interesuje, i kliknij czytelny link do głównej strony, gdy będziesz gotowy zobaczyć więcej.",
    cta: "Dowiedz się więcej o USFans Spreadsheet",
  },
  why: {
    title: "Dlaczego warto korzystać z tego źródła?",
    subtitle: "Spokojny, uporządkowany sposób przeglądania — stworzony dla szybkości i przejrzystości.",
    c1title: "Uporządkowane informacje",
    c1desc: "Kategorie są pogrupowane, dzięki czemu znajdziesz właściwą sekcję w kilka sekund.",
    c2title: "Łatwe odkrywanie",
    c2desc: "Prosta lista rozwijana i czytelne przyciski sprawiają, że przeglądanie jest bez wysiłku.",
    c3title: "Przydatne porównania",
    c3desc: "Zobacz kategorie obok siebie i zdecyduj, gdzie zajrzeć dalej.",
    c4title: "Nastawione na bezpieczeństwo",
    c4desc: "Jasne wskazówki pomagają przeglądać i klikać linki z pewnością.",
  },
  guides: {
    title: "Najnowsze poradniki",
    subtitle:
      "Oryginalne, praktyczne artykuły o USFans Spreadsheet i o tym, jak najlepiej z niego korzystać.",
    readMore: "Przeczytaj poradnik",
    comingSoon: "Wkrótce",
    comingTitle1: "USFans Review: co warto wiedzieć",
    comingExcerpt1: "Bliższe spojrzenie na funkcje, wady, zalety i praktyczne uwagi.",
    comingCategory1: "Recenzja",
    comingTitle2: "USFans Shipping Cost Guide",
    comingExcerpt2: "Czynniki wysyłki, ceny i kwestie dostawy wyjaśnione.",
    comingCategory2: "Wysyłka",
  },
  faq: {
    title: "Najczęściej zadawane pytania",
    subtitle: "Szybkie odpowiedzi na częste pytania dotyczące USFans Spreadsheet.",
    q1: "Czym jest USFans Spreadsheet?",
    a1: "To uporządkowane źródło, które grupuje kategorie modowe i lifestyle'owe w jeden łatwy do przeglądania widok z czytelnymi linkami do głównej strony.",
    q2: "Jak przeglądać kategorie?",
    a2: "Użyj listy rozwijanej lub przycisków kategorii na stronie głównej. Oba prowadzą do odpowiadającej sekcji na głównej stronie.",
    q3: "Czy USFans Spreadsheet jest darmowy?",
    a3: "Tak, przeglądanie jest całkowicie darmowe i nie wymaga zakładania konta.",
    q4: "Jak często aktualizowane są informacje?",
    a4: "Źródło jest regularnie odświeżane, aby linki kategorii były dokładne i aktualne.",
    q5: "Dokąd prowadzą linki kategorii?",
    a5: "Każdy link prowadzi do odpowiadającej sekcji kategorii na głównej stronie.",
    q6: "Jak zachować bezpieczeństwo podczas przeglądania?",
    a6: "Sprawdzaj adres strony, trzymaj dane logowania i płatności w tajemnicy oraz unikaj udostępniania danych osobowych niezaufanym źródłom.",
  },
  cta: {
    title: "Zacznij odkrywać USFans Spreadsheet",
    desc: "Znajdź uporządkowane kategorie, praktyczne poradniki i przydatne zasoby w jednym miejscu.",
    primary: "Przeglądaj USFans Spreadsheet",
    secondary: "Odwiedź główną stronę",
  },
  footer: {
    about:
      "USFans Link to niezależne centrum zasobów oparte na USFans Spreadsheet, pomagające odwiedzającym przeglądać kategorie, czytać poradniki i znajdować przydatne informacje.",
    quickLinks: "Szybkie linki",
    categories: "Kategorie",
    resources: "Zasoby",
    guides: "Poradniki",
    faq: "FAQ",
    home: "Strona główna",
    rights: "Wszelkie prawa zastrzeżone.",
    disclaimer:
      "USFans Link jest niezależnym źródłem i nie jest powiązany z główną stroną. Linki produktowe prowadzą do oficjalnego sklepu.",
  },
  notFound: {
    title: "Nie znaleziono strony",
    desc: "Strona, której szukasz, nie istnieje lub została przeniesiona. Wróć na stronę główną, aby kontynuować przeglądanie.",
  },
};